module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-893e94720235aa87bb04006d499f4bc7.png";